import { render, staticRenderFns } from "./webhookworkspace.vue?vue&type=template&id=97cc7db8&scoped=true"
import script from "./webhookworkspace.vue?vue&type=script&lang=js"
export * from "./webhookworkspace.vue?vue&type=script&lang=js"
import style0 from "./webhookworkspace.vue?vue&type=style&index=0&id=97cc7db8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cc7db8",
  null
  
)

export default component.exports